import { ShowDashboardRequestSchema, ShowDashboardResponseSchema } from './show-dashboard.schema';
export const showDashboardContract = {
    method: 'GET',
    path: '/api/v2/dashboard',
    description: 'Retrieve aggregated dashboard data for the current user',
    requestSchema: ShowDashboardRequestSchema,
    responseSchema: ShowDashboardResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user lacks Dashboard read permission'
        }
    }
};

//# sourceMappingURL=show-dashboard.contract.js.map